export default __webpack_public_path__ + "static/media/me1.151e18da.png";